import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { balanceSheetsQueryKey, financialPeriodsQueryKey } from "../../financials";

export function useAdminCreateBalanceSheet(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (data: Dtos.Admin.BalanceSheet.Create.Request) =>
			post<Dtos.Admin.BalanceSheet.Create.Response>(
				`/v2/admin/surety/accounts/${accountId}/balance-sheets`,
				data,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: balanceSheetsQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: financialPeriodsQueryKey(accountId) });
		},
	});

	return {
		createBalanceSheet: mutation.mutate,
		createBSLoading: mutation.isPending,
		createBSError: mutation.error,
		resetCreateBSError: mutation.reset,
	};
}
